import { Box } from '@mui/material'
import { useContext } from 'react'

// others
import { useDeleteCategoryMutation } from '../../../../generated'
import { NOT_APPLICABLE } from '../../../constants'
import { AppContext } from '../../../context'
import { ActionType } from '../../../context/AppContextReducer'
import { CategoryMenuProps } from '../../../interfaceTypes/props'

// components
import { Alert } from '../../common/Alert'
import CustomMenu from '../../common/CustomMenu'
import { DeleteModalContent } from '../../common/DeleteModalContent'
import CategoryModal from './CategoryModal'

const CategoryMenu = ({ category, refetch }: CategoryMenuProps) => {
  const { dispatch } = useContext(AppContext)
  
  const { id: categoryId = '' } = category ?? {}
  
  const [deleteCategory, { loading: deleting }] = useDeleteCategoryMutation({
      onError: error => {
        Alert.error(`Category couldn't be deleted due to: ${error.message}`)
      },
      onCompleted: () => {
        dispatch({ type: ActionType.SET_IS_DELETE_OPEN, isDeleteOpen: false })
        Alert.success('Category deleted successfully')
        refetch()
      }
    })
  
  const onDeleteCategory = async (categoryId: string) => await deleteCategory({ variables: { deleteCategoryId: categoryId } })
  
  return ( 
    <CustomMenu 
      id={categoryId} 
      menuTitle='Category' 
      onDelete={onDeleteCategory} 
      deleteContent={
        <Box mt={1}>
         <DeleteModalContent label="Name" value={category?.name || NOT_APPLICABLE} />
         <DeleteModalContent label="Description" value={category?.description || NOT_APPLICABLE} />
        </Box>
      }
      deleting={deleting}
      modal={
        <CategoryModal category={category} refetch={refetch} />}   
    />
  )
}

export default CategoryMenu